let GridRef = function () {
  this.instance = {}
}
GridRef.prototype.set = function (item, row, col) {
  if (!this.instance[row]) {
    this.instance[row] = {}
  }
  this.instance[row][col] = item
}
GridRef.prototype.get = function (row, col) {
  if (this.instance[row] && this.instance[row][col]) {
    return this.instance[row][col]
  } else {
    return null
  }
}
export default GridRef



// WEBPACK FOOTER //
// ./src/components/grid/gridRef.js